!(function (c) {
  var e = function (a) {
    c(a).on('click', '[data-dismiss="alert"]', this.close);
  };
  e.prototype = {
    constructor: e,
    close: function (a) {
      function b() {
        g.trigger('closed').remove();
      }
      var d = c(this),
        f = d.attr('data-target'),
        g;
      f || (f = (f = d.attr('href')) && f.replace(/.*(?=#[^\s]*$)/, ''));
      g = c(f);
      g.trigger('close');
      a && a.preventDefault();
      g.length || (g = d.hasClass('alert') ? d : d.parent());
      g.trigger('close').removeClass('in');
      c.support.transition && g.hasClass('fade')
        ? g.on(c.support.transition.end, b)
        : b();
    },
  };
  c.fn.alert = function (a) {
    return this.each(function () {
      var b = c(this),
        d = b.data('alert');
      d || b.data('alert', (d = new e(this)));
      'string' == typeof a && d[a].call(b);
    });
  };
  c.fn.alert.Constructor = e;
  c(function () {
    c('body').on(
      'click.alert.data-api',
      '[data-dismiss="alert"]',
      e.prototype.close
    );
  });
})($);
!(function (c) {
  function e() {
    this.$element.hide().trigger('hidden');
    a.call(this);
  }
  function a(a) {
    var d = this.$element.hasClass('fade') ? 'fade' : '';
    if (this.isShown && this.options.backdrop) {
      var f = c.support.transition && d;
      this.$backdrop = c('<div class="modal-backdrop ' + d + '" />').appendTo(
        document.body
      );
      'static' != this.options.backdrop &&
        this.$backdrop.click(c.proxy(this.hide, this));
      f && this.$backdrop[0].offsetWidth;
      this.$backdrop.addClass('in');
      f ? this.$backdrop.one(c.support.transition.end, a) : a();
    } else
      !this.isShown && this.$backdrop
        ? (this.$backdrop.removeClass('in'),
          c.support.transition && this.$element.hasClass('fade')
            ? this.$backdrop.one(c.support.transition.end, c.proxy(b, this))
            : b.call(this))
        : a && a();
  }
  function b() {
    this.$backdrop.remove();
    this.$backdrop = null;
  }
  function d() {
    var a = this;
    if (this.isShown && this.options.keyboard)
      c(document).on('keyup.dismiss.modal', function (c) {
        27 == c.which &&
          (window._gaq.push([
            '_trackEvent',
            'Signup',
            'thickbox_closed_escape_pressed',
          ]),
          a.hide());
      });
    else this.isShown || c(document).off('keyup.dismiss.modal');
  }
  var f = function (a, b) {
    this.options = b;
    this.$element = c(a).delegate(
      '[data-dismiss="modal"]',
      'click.dismiss.modal',
      c.proxy(this.hide, this)
    );
  };
  f.prototype = {
    constructor: f,
    toggle: function () {
      return this[!this.isShown ? 'show' : 'hide']();
    },
    show: function () {
      var b = this;
      this.isShown ||
        (c('body').addClass('modal-open'),
        (this.isShown = !0),
        this.$element.trigger('show'),
        d.call(this),
        a.call(this, function () {
          var a = c.support.transition && b.$element.hasClass('fade');
          !b.$element.parent().length && b.$element.appendTo(document.body);
          b.$element.show();
          a && b.$element[0].offsetWidth;
          b.$element.addClass('in');
          a
            ? b.$element.one(c.support.transition.end, function () {
                b.$element.trigger('shown');
              })
            : b.$element.trigger('shown');
        }));
    },
    hide: function (a) {
      a && a.preventDefault();
      if (this.isShown)
        if (
          ((this.isShown = !1),
          c('body').removeClass('modal-open'),
          d.call(this),
          this.$element.trigger('hide').removeClass('in'),
          c.support.transition && this.$element.hasClass('fade'))
        ) {
          var b = this,
            f = setTimeout(function () {
              b.$element.off(c.support.transition.end);
              e.call(b);
            }, 500);
          this.$element.one(c.support.transition.end, function () {
            clearTimeout(f);
            e.call(b);
          });
        } else e.call(this);
    },
  };
  c.fn.modal = function (a) {
    return this.each(function () {
      var b = c(this),
        d = b.data('modal'),
        e = c.extend(
          {},
          c.fn.modal.defaults,
          b.data(),
          'object' == typeof a && a
        );
      d || b.data('modal', (d = new f(this, e)));
      if ('string' == typeof a) d[a]();
      else e.show && d.show();
    });
  };
  c.fn.modal.defaults = { backdrop: !0, keyboard: !0, show: !0 };
  c.fn.modal.Constructor = f;
  c(function () {
    c('body').on('click.modal.data-api', '[data-toggle="modal"]', function (a) {
      var b = c(this),
        d,
        f = c(
          b.attr('data-target') ||
            ((d = b.attr('href')) && d.replace(/.*(?=#[^\s]+$)/, ''))
        ),
        b = f.data('modal') ? 'toggle' : c.extend({}, f.data(), b.data());
      a.preventDefault();
      f.modal(b);
    });
  });
})($);
!(function (c) {
  function e() {
    c(a).parent().removeClass('open');
  }
  var a = '[data-toggle="dropdown"]',
    b = function (a) {
      var b = c(a).on('click.dropdown.data-api', this.toggle);
      c('html').on('click.dropdown.data-api', function () {
        b.parent().removeClass('open');
      });
    };
  b.prototype = {
    constructor: b,
    toggle: function () {
      var a = c(this),
        b = a.attr('data-target');
      b || (b = (b = a.attr('href')) && b.replace(/.*(?=#[^\s]*$)/, ''));
      b = c(b);
      b.length || (b = a.parent());
      a = b.hasClass('open');
      e();
      !a && b.toggleClass('open');
      return !1;
    },
  };
  c.fn.dropdown = function (a) {
    return this.each(function () {
      var f = c(this),
        e = f.data('dropdown');
      e || f.data('dropdown', (e = new b(this)));
      'string' == typeof a && e[a].call(f);
    });
  };
  c.fn.dropdown.Constructor = b;
  c(function () {
    c('html').on('click.dropdown.data-api', e);
    c('body').on('click.dropdown.data-api', a, b.prototype.toggle);
  });
})($);
!(function (c) {
  var e = function (a, b) {
    this.init('tooltip', a, b);
  };
  e.prototype = {
    constructor: e,
    init: function (a, b, d) {
      this.type = a;
      this.$element = c(b);
      this.options = this.getOptions(d);
      this.enabled = !0;
      'manual' != this.options.trigger &&
        ((a = 'hover' == this.options.trigger ? 'mouseenter' : 'focus'),
        (b = 'hover' == this.options.trigger ? 'mouseleave' : 'blur'),
        this.$element.on(a, this.options.selector, c.proxy(this.enter, this)),
        this.$element.on(b, this.options.selector, c.proxy(this.leave, this)));
      this.options.selector
        ? (this._options = c.extend({}, this.options, {
            trigger: 'manual',
            selector: '',
          }))
        : this.fixTitle();
    },
    getOptions: function (a) {
      a = c.extend({}, c.fn[this.type].defaults, a, this.$element.data());
      a.delay &&
        'number' == typeof a.delay &&
        (a.delay = { show: a.delay, hide: a.delay });
      return a;
    },
    enter: function (a) {
      var b = c(a.currentTarget)[this.type](this._options).data(this.type);
      !b.options.delay || !b.options.delay.show
        ? b.show()
        : ((b.hoverState = 'in'),
          setTimeout(function () {
            'in' == b.hoverState && b.show();
          }, b.options.delay.show));
    },
    leave: function (a) {
      var b = c(a.currentTarget)[this.type](this._options).data(this.type);
      !b.options.delay || !b.options.delay.hide
        ? b.hide()
        : ((b.hoverState = 'out'),
          setTimeout(function () {
            'out' == b.hoverState && b.hide();
          }, b.options.delay.hide));
    },
    show: function () {
      var a, b, c, f, e, h, i;
      if (this.hasContent() && this.enabled) {
        a = this.tip();
        this.setContent();
        this.options.animation && a.addClass('fade');
        h =
          'function' == typeof this.options.placement
            ? this.options.placement.call(this, a[0], this.$element[0])
            : this.options.placement;
        b = /in/.test(h);
        a.remove()
          .css({ top: 0, left: 0, display: 'block' })
          .appendTo(b ? this.$element : document.body);
        c = this.getPosition(b);
        f = a[0].offsetWidth;
        e = a[0].offsetHeight;
        switch (b ? h.split(' ')[1] : h) {
          case 'bottom':
            i = { top: c.top + c.height, left: c.left + c.width / 2 - f / 2 };
            break;
          case 'top':
            i = { top: c.top - e, left: c.left + c.width / 2 - f / 2 };
            break;
          case 'left':
            i = { top: c.top + c.height / 2 - e / 2, left: c.left - f };
            break;
          case 'right':
            i = { top: c.top + c.height / 2 - e / 2, left: c.left + c.width };
        }
        a.css(i).addClass(h).addClass('in');
      }
    },
    setContent: function () {
      var a = this.tip();
      a.find('.tooltip-inner').html(this.getTitle());
      a.removeClass('fade in top bottom left right');
    },
    hide: function () {
      var a = this.tip();
      a.removeClass('in');
      if (c.support.transition && this.$tip.hasClass('fade')) {
        var b = setTimeout(function () {
          a.off(c.support.transition.end).remove();
        }, 500);
        a.one(c.support.transition.end, function () {
          clearTimeout(b);
          a.remove();
        });
      } else a.remove();
    },
    fixTitle: function () {
      var a = this.$element;
      if (a.attr('title') || 'string' != typeof a.attr('data-original-title'))
        a.attr('data-original-title', a.attr('title') || '').removeAttr(
          'title'
        );
    },
    hasContent: function () {
      return this.getTitle();
    },
    getPosition: function (a) {
      return c.extend({}, a ? { top: 0, left: 0 } : this.$element.offset(), {
        width: this.$element[0].offsetWidth,
        height: this.$element[0].offsetHeight,
      });
    },
    getTitle: function () {
      var a;
      a = this.$element;
      var b = this.options;
      a =
        a.attr('data-original-title') ||
        ('function' == typeof b.title ? b.title.call(a[0]) : b.title);
      return (a = (a || '').toString().replace(/(^\s*|\s*$)/, ''));
    },
    tip: function () {
      return (this.$tip = this.$tip || c(this.options.template));
    },
    validate: function () {
      this.$element[0].parentNode ||
        (this.hide(), (this.options = this.$element = null));
    },
    enable: function () {
      this.enabled = !0;
    },
    disable: function () {
      this.enabled = !1;
    },
    toggleEnabled: function () {
      this.enabled = !this.enabled;
    },
    toggle: function () {
      this[this.tip().hasClass('in') ? 'hide' : 'show']();
    },
  };
  c.fn.tooltip = function (a) {
    return this.each(function () {
      var b = c(this),
        d = b.data('tooltip'),
        f = 'object' == typeof a && a;
      d || b.data('tooltip', (d = new e(this, f)));
      if ('string' == typeof a) d[a]();
    });
  };
  c.fn.tooltip.Constructor = e;
  c.fn.tooltip.defaults = {
    animation: !0,
    delay: 0,
    selector: !1,
    placement: 'top',
    trigger: 'hover',
    title: '',
    template:
      '<div class="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
  };
})($);
!(function (c) {
  var e = function (a, b) {
    this.init('popover', a, b);
  };
  e.prototype = c.extend({}, c.fn.tooltip.Constructor.prototype, {
    constructor: e,
    setContent: function () {
      var a = this.tip(),
        b = this.getTitle(),
        d = this.getContent();
      a.find('.popover-title')['object' == c.type(b) ? 'append' : 'html'](b);
      a.find('.popover-content > *')['object' == c.type(d) ? 'append' : 'html'](
        d
      );
      a.removeClass('fade top bottom left right in');
    },
    hasContent: function () {
      return this.getTitle() || this.getContent();
    },
    getContent: function () {
      var a;
      a = this.$element;
      var b = this.options;
      a =
        a.attr('data-content') ||
        ('function' == typeof b.content ? b.content.call(a[0]) : b.content);
      return (a = a.toString().replace(/(^\s*|\s*$)/, ''));
    },
    tip: function () {
      this.$tip || (this.$tip = c(this.options.template));
      return this.$tip;
    },
  });
  c.fn.popover = function (a) {
    return this.each(function () {
      var b = c(this),
        d = b.data('popover'),
        f = 'object' == typeof a && a;
      d || b.data('popover', (d = new e(this, f)));
      if ('string' == typeof a) d[a]();
    });
  };
  c.fn.popover.Constructor = e;
  c.fn.popover.defaults = c.extend({}, c.fn.tooltip.defaults, {
    placement: 'right',
    content: '',
    template:
      '<div class="popover"><div class="arrow"></div><div class="popover-inner"><h3 class="popover-title"></h3><div class="popover-content"><p></p></div></div></div>',
  });
})($);
$('[rel=tooltip-b]').tooltip({ placement: 'bottom' });
$('[rel=tooltip]').tooltip();
$('[rel=tooltip-focus]').tooltip({ trigger: 'focus' });
